$(document).ready(function () {

    // ============================================================
    // KOŠÍK — id--9
    // ============================================================

    if ($(".id--9").length > 0) {
        initCart();
        initEmptyCartButton();
    }

    // ============================================================
    // DOPRAVA A PLATBA — id--16
    // ============================================================

    if ($(".id--16").length > 0) {
        initOrderSummaryImages();
    }

    // ============================================================
    // INFORMACE O VÁS — id--17
    // ============================================================

    if ($(".id--17").length > 0) {
        initOrderSummaryImages();
    }

    // Vynucení firemních barev na konverzních/zpět tlačítkách (téma je zamyká)
    styleNextStepButtons();

});

document.addEventListener("ShoptetDOMContentLoaded", function () {

    if ($(".id--9").length > 0) {
        initCart();
        initEmptyCartButton();
    }

    if ($(".id--16").length > 0) {
        initOrderSummaryImages();
    }

    if ($(".id--17").length > 0) {
        initOrderSummaryImages();
    }

    // Vynucení firemních barev na konverzních/zpět tlačítkách (téma je zamyká)
    styleNextStepButtons();

});

// ============================================================
// Funkce: init košíku
// — přepíše related→orig v obrázcích, přidá discount-coupon titulek,
//   uloží mapu obrázků do localStorage
// ============================================================

function initCart() {

    // Přepis related → orig pro vyšší kvalitu obrázků
    $(".cart-table tr.removeable").each(function () {
        const $img = $(this).find("td.cart-p-image img");
        const dataSrc = $img.attr("data-src") || "";
        const src = $img.attr("src") || "";
        if (dataSrc) {
            $img.attr("data-src", dataSrc.replace("/related/", "/orig/"));
        }
        if (src) {
            $img.attr("src", src.replace("/related/", "/orig/"));
        }
    });

    // Přidání titulku k discount-coupon (idempotentní) — bez textu z datalayeru se nevykreslí
    const couponTitle = getShopDataLayer().cart.discountCouponTitle;
    if (couponTitle && $(".discount-coupon").length > 0 && $(".discount-coupon__title").length === 0) {
        $("<h4 class='discount-coupon__title'>" + couponTitle + "</h4>").prependTo(".discount-coupon");
    }

    // Uložení mapy obrázků do localStorage
    saveCartItemsToStorage();
}

// ============================================================
// Funkce: uloží { imgSrc: identifier } do localStorage["cartItems"]
// ============================================================

function saveCartItemsToStorage() {
    const newItems = {};

    $("tr.removeable").each(function () {
        const identifier = $(this).attr("data-micro-identifier");
        let imgSrc = $(this).find("td.cart-p-image img").attr("data-src") || $(this).find("td.cart-p-image img").attr("src");

        if (identifier && imgSrc) {
            // Zajisti orig variantu
            imgSrc = imgSrc.replace("/related/", "/orig/");
            newItems[imgSrc] = identifier;
        }
    });

    // Uložit do localStorage
    localStorage.setItem("cartItems", JSON.stringify(newItems));

    // Odstraň položky které už v košíku nejsou
    const savedItems = JSON.parse(localStorage.getItem("cartItems")) || {};
    $.each(savedItems, function (key) {
        if (!newItems[key]) {
            delete savedItems[key];
        }
    });
    localStorage.setItem("cartItems", JSON.stringify(savedItems));
}

// ============================================================
// Funkce: vloží tlačítko "Zpět do obchodu" do prázdného košíku
// — funguje pro oba stavy prázdného košíku:
//   1) redirect (přímý vstup) — nadpis je <h1 class="h1 cart-heading">
//   2) AJAX (odebrání poslední položky) — nadpis je <div class="h1 cart-heading">,
//      na body přibude třída .cart-emptied; tento stav chytá listener
//      ShoptetDOMContentLoaded níže (AJAX reload nahradí celý #cart-wrapper)
// Cíl vložení je v obou případech .cart-inner.cart-empty .cart-heading (= .h1).
// Texty i odkaz jdou ze shopDataLayer.cart.emptyCartButton — žádné hardcoded hodnoty.
// Idempotentní — tlačítko nepřidá dvakrát.
// ============================================================

function initEmptyCartButton() {
    const config = getShopDataLayer().cart.emptyCartButton || {};

    const $heading = $(".cart-inner.cart-empty .cart-heading");

    // Vlož jen pokud je košík prázdný, máme texty z datalayeru a tlačítko tam ještě není
    if ($heading.length === 0 || !config.text || !config.link) {
        return;
    }
    if ($heading.next(".empty-cart-holder").length > 0) {
        return;
    }

    $("<div class='btn-holder empty-cart-holder'>" +
        "<a class='btn btn-secondary empty-cart-back-btn' href='" + config.link + "'>" + config.text + "</a>" +
    "</div>").insertAfter($heading);
}

// ============================================================
// Funkce: doplní .img-holder do .order-summary-item (kroky 2 a 3)
// Idempotentní — nepřidá obrázek dvakrát
// ============================================================

function initOrderSummaryImages() {
    const cartItems = JSON.parse(localStorage.getItem("cartItems")) || {};

    $(".order-summary-item[data-micro-identifier]").each(function () {
        // Přeskočit pokud img-holder už existuje
        if ($(this).find(".img-holder").length > 0) {
            return;
        }

        const identifier = $(this).attr("data-micro-identifier");
        let foundSrc = null;

        $.each(cartItems, function (imgSrc, storedIdentifier) {
            if (storedIdentifier === identifier) {
                foundSrc = imgSrc;
                return false; // Zastavit $.each
            }
        });

        if (foundSrc) {
            $("<div class='img-holder'><img src='" + foundSrc + "' alt=''></div>").prependTo($(this));
        }
    });
}


// ============================================================
// Funkce: vynutí firemní barvy na .next-step tlačítkách
// Shoptet téma zamyká barvy .btn-conversion / .next-step-back přes vysoce
// specifická !important pravidla (jiná id na každé stránce — #continue-order-button,
// #orderFormButton), která stylesheet ani s !important spolehlivě nepřebije.
// Inline styl s prioritou "important" stojí nad nimi → barvy nastavíme přímo na element.
// Geometrie, typografie a hover zůstávají z @include btn() v cart.scss.
// ============================================================

function styleNextStepButtons() {

    // Primární (zelené) — pokračovat / dokončit
    $(".next-step .next-step-forward, .next-step .next-step-finish").each(function () {
        this.style.setProperty("background-color", "#5a665d", "important");
        this.style.setProperty("color", "#fff", "important");
        this.style.setProperty("border-color", "#5a665d", "important");
    });

    // Sekundární (outline) — zpět do obchodu / zpět
    $(".next-step .next-step-back").each(function () {
        this.style.setProperty("background-color", "transparent", "important");
        this.style.setProperty("color", "#5a665d", "important");
        this.style.setProperty("border-color", "#5a665d", "important");
    });
}
